
import React, { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { 
  Navbar, 
  BookingForm, 
  Hero, 
  Services, 
  Tarifs, 
  About, 
  Gallery, 
  Reviews, 
  Contact, 
  Footer, 
  Auth, 
  AdminPanel, 
  Profile, 
  ForgotPassword, 
  ResetPassword,
  UserBookings
} from './components';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';

const AppContent = () => {
  const { lang, setLang, t } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(''); 
  const [currentUser, setCurrentUser] = useState(null);

  const handleLogin = (user) => {
    setIsAuthenticated(true);
    setUserRole(user.role);
    setCurrentUser(user);
    if (user.preferred_language) setLang(user.preferred_language);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserRole('');
    setCurrentUser(null);
  };

  const ProtectedRoute = ({ children, requiredRole }) => {
    const location = useLocation();
    if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
    if (requiredRole && userRole !== requiredRole) return <Navigate to="/" replace />;
    return children;
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col selection:bg-brand-100 selection:text-brand-900">
      <Navbar 
        lang={lang} 
        setLang={setLang}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        t={t}
        onLogout={handleLogout}
        userRole={userRole}
        isAuthenticated={isAuthenticated}
        user={currentUser}
      />

      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Hero t={t} />} />
          <Route path="/tarifs" element={<Tarifs t={t} lang={lang} />} />
          <Route path="/reviews" element={<Reviews t={t} user={currentUser} />} />
          <Route path="/services" element={<Services t={t} lang={lang} />} />
          <Route path="/about" element={<About t={t} />} />
          <Route path="/gallery" element={<Gallery t={t} />} />
          <Route path="/contact" element={<Contact t={t} />} />
          
          <Route path="/login" element={
            isAuthenticated ? <Navigate to="/" /> : 
            <Auth onLogin={handleLogin} t={t} lang={lang} setLang={setLang} />
          } />
          
          <Route path="/forgot-password" element={<ForgotPassword t={t} />} />
          <Route path="/reset-password" element={<ResetPassword t={t} />} />

          <Route path="/booking" element={
            <ProtectedRoute>
              <BookingForm t={t} lang={lang} />
            </ProtectedRoute>
          } />

          <Route path="/profile" element={
            <ProtectedRoute>
              <Profile t={t} user={currentUser} setUser={setCurrentUser} setLang={setLang} />
            </ProtectedRoute>
          } />

          <Route path="/my-bookings" element={
            <ProtectedRoute>
              <UserBookings t={t} user={currentUser} lang={lang} />
            </ProtectedRoute>
          } />

          <Route path="/admin" element={
            <ProtectedRoute requiredRole="admin">
              <AdminPanel t={t} user={currentUser} lang={lang} />
            </ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
};

export default function HomeSalonWebsite() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}
